import { render, staticRenderFns } from "./AdxHealth.vue?vue&type=template&id=28745e9b&"
import script from "./AdxHealth.vue?vue&type=script&lang=js&"
export * from "./AdxHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports